export enum BenefitChangeState {
  NEW = 'NEW',
  EDITED = 'EDITED',
  ACTIVE = 'ACTIVE'
}

export const BenefitChangeStateTranslation = {
  [BenefitChangeState.NEW]: 'Nowe',
  [BenefitChangeState.EDITED]: 'Edytowane',
  [BenefitChangeState.ACTIVE]: 'Zaakceptowane'
};
